import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Link, LinkProps } from 'react-router-dom';
import getCurrentCategory from 'store/category/selector/getCurrentCategory';
import getCategoryId from 'store/category/selector/getCategoryId';
import cn from 'classnames';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import { useTranslation } from 'react-i18next';
import styles from './CategoriesList.module.scss';
import CategoryMenu from '../CategoryMenu/CategoryMenu';

export const ConditionalLink: FC<LinkProps & React.RefAttributes<HTMLDivElement> & { hasChild: boolean }> = ({
  to,
  children,
  className,
  onClick,
  hasChild,
}) => {
  if (hasChild) {
    return (
      <span onClick={onClick} className={cn(className, styles.cursor, styles.link)}>
        {children}
      </span>
    );
  }
  return (
    <Link to={to} className={cn(className, styles.link)} onClick={onClick}>
      {children}
    </Link>
  );
};

const CategoriesList = () => {
  const currentCategoryInfo = useSelector(getCurrentCategory);
  const currentCategoryId = useSelector(getCategoryId);
  const { t } = useTranslation();

  if (!currentCategoryInfo?.sidebarItems.length || !currentCategoryId) {
    return null;
  }

  return (
    <div className={styles.categoriesList}>
      <OpText variant="body-large-bold">{t('txt_collections')}</OpText>

      <div className={styles.menu}>
        <CategoryMenu items={currentCategoryInfo.sidebarItems} levelNum={1} />
      </div>
    </div>
  );
};

export default CategoriesList;
